<template>
  <vs-popup title="Encerrar atendimentos" :active.sync="isActive" v-on:close="onFinalizeModalClose" class="sizePopup">
      <div class="w-full">
        <ol class="mb-4">
          <li class="mb-2">
            <vs-radio color="primary" v-model="option" vs-name="radioToFinalize" vs-value="all">
              Atendimentos Abertos
            </vs-radio>
          </li>

          <li class="mb-2">
            <vs-radio color="primary" v-model="option" vs-name="radioToFinalize" vs-value="old">
              Atendimentos de Dias Anteriores Abertos
            </vs-radio>
          </li>

          <li class="mb-2">
            <vs-radio color="primary" v-model="option" vs-name="radioToFinalize" vs-value="user">
              Atendimentos de Usuários Específicos
            </vs-radio>
          </li>

          <li class="mb-2">
            <vs-radio color="primary" v-model="option" vs-name="radioToFinalize" vs-value="instance">
              Atendimentos de Conexões Específicas
            </vs-radio>
          </li>
          
          <hr v-if="settings.relate_chat_tickets_to_next_user === '0'">
          <br v-if="settings.relate_chat_tickets_to_next_user === '0'">

          <li class="mb-2">
            <vs-radio
              color="primary"
              v-model="option"
              vs-name="radioToFinalize"
              vs-value="inbox"
              v-if="settings.relate_chat_tickets_to_next_user === '0'">
              Atendimentos da Caixa de Entrada
            </vs-radio>
          </li>

          <li class="mb-2">
            <vs-radio 
            color="primary" 
            v-model="option" 
            vs-name="radioToFinalize" 
            vs-value="inbox_instance"
            v-if="settings.relate_chat_tickets_to_next_user === '0'">
              Atendimentos da Caixa de Entrada por Conexão Específica
            </vs-radio>
          </li>
        </ol>

        <users-slim-list checkbox v-if="option === 'user'" :selecteds="userIds" @selectedUsers="updateUserIds"/>
        <instances-slim-list checkbox v-if="option === 'instance'" :selecteds="instanceIds" @selectedInstances="updateInstanceIds"/>
        <instances-slim-list checkbox v-if="option === 'inbox_instance'" :selecteds="instanceIds" @selectedInstances="updateInstanceIds"/>

        <div>
          <vs-alert active="true" color="warning" class="no-message-alert mb-4">
            Não será enviada nenhuma mensagem informando o fim do atendimento
          </vs-alert>
        </div>

        <div>
          <vs-button
            color="primary"
            type="filled"
            class="align-right"
            @click.prevent="finalizeChats()"
          >
            <span>Encerrar Atendimentos</span>
          </vs-button>
        </div>
      </div>
    </vs-popup>
</template>
<script>
  import UsersSlimList from '../users/UsersSlimList'
  import InstancesSlimList from '../instances/InstancesSlimList'
  import { finishChatTicketBatch } from '@/http/requests/chatTicket'

  import moduleSettings from '@/store/settings/moduleSettings'

  export default {
    name: 'finalize-batch-popup',
    data() {
      return {
        option: 'all',
        userIds: [],
        instanceIds: [],
        opened: false,
      }
    },
    props: {
      isActive: {
        type: Boolean,
        required: true
      },
    },
    computed: {
      settings() {
        return this.$store.state.settings.settings
      }
    },
    watch:{
      isActive(value){
        if (!value){
          this.option = 'all'
          this.userIds = []
          this.instanceIds = []
        }
      }
    },
    methods: {
      updateUserIds(list) {
        this.userIds = list;
      },
      updateInstanceIds(list) {
        this.instanceIds = list;
      },
      finalizeChats() {
        if (this.option === 'user' && this.userIds.length === 0) {
          this.$vs.notify({
            color: 'danger',
            title: 'Atenção!',
            text: 'Selecione pelo menos um usuário!'
          })
        } else if (this.option === 'instance' && this.instanceIds.length === 0) {
          this.$vs.notify({
            color: 'danger',
            title: 'Atenção!',
            text: 'Selecione pelo menos uma conexão!'
          })
        } else if (this.option === 'inbox_instance' && this.instanceIds.length === 0) {
          this.$vs.notify({
            color: 'danger',
            title: 'Atenção!',
            text: 'Selecione pelo menos uma conexão!'
          })
        }
        else {
          this.$store.dispatch('setShowLoadingOverlay', true)

          finishChatTicketBatch(this.option, this.userIds, this.instanceIds, true).then((response) => {
            if (response.data.data.finishChatTicketBatch === true) {
              this.$vs.notify({
                color: 'success',
                title: 'Sucesso!',
                text: 'Atendimentos encerrados com sucesso!'
              })
            } else {
              this.$vs.notify({
                color: 'warning',
                title: 'Atenção!',
                text: 'Não há atendimentos a serem encerrados!'
              })
            }
            this.$store.dispatch('setShowLoadingOverlay', false)
            this.onFinalizeModalClose()
          }).catch((error) => {
            this.$store.dispatch('setShowLoadingOverlay', false)
            this.onFinalizeModalClose()
            console.log(error)
          })
        }
      },
      onFinalizeModalClose() {
        this.opened = false
        this.option = 'all'
        this.userIds = []
        this.$emit('isActiveFalse');
      },
    },
    components: {
      UsersSlimList,
      InstancesSlimList
    },
    mounted() {
      if (!moduleSettings.isRegistered) {
        this.$store.registerModule('settings', moduleSettings)
        moduleSettings.isRegistered = true
      }
      
      this.$store.dispatch("settings/fetch")

      this.$parent.$on('change-finalize-batch', ({option, instanceIds = [], userIds = []}) => {
        this.option = option
        this.userIds = userIds
        this.instanceIds = instanceIds
      });
    },
    beforeDestroy() {
      this.$parent.$off('change-finalize-batch');
    }
  };
</script>

<style type="text/css">
  .no-message-alert {
    height: auto !important;
  }
</style>
